/**!
 * Created by Leonardo Cheslacki on 25/06/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class SupportStyle extends SupportController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            text: null
        };

        this.$document = window.top.document;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @param name
     * @param callback
     */
    find = (name, callback) => {
        if (!this.isEmpty(name)) {
            name = this.toSlug(name);
            Array.from(this.$document.styleSheets).forEach((styleSheet) => {
                let ownerNode = styleSheet.ownerNode;
                if (ownerNode.localName === 'style' && styleSheet.cssRules) {
                    let dataMeta = ownerNode.attributes.getNamedItem('data-meta');
                    (!!dataMeta && (dataMeta.value === name) && (typeof(callback) === 'function')) && callback(ownerNode);
                }
            });
        }
    }

    /**
     *
     * @param name
     */
    remove = (name) => {
        this.find(name, (ownerNode) => {
            this.$document.head.removeChild(ownerNode);
        });
    };

    /**
     *
     * @param name
     * @param document
     */
    create = (name, document = window.top.document) => {
        this.$document = document;
        if (!this.isEmpty(name) && !this.isEmpty(this.state.text)) {
            this.remove(name);
            let
                style = this.$document.createElement('STYLE'),
                attributeDataMeta = this.$document.createAttribute('data-meta');

            attributeDataMeta.value = this.toSlug(name);
            style.setAttributeNode(attributeDataMeta);
            style.type = 'text/css';
            style.appendChild(this.$document.createTextNode(this.state.text));
            this.$document.head.appendChild(style);
        }
    };

    /**
     *
     * @param object
     * Example:
     *    canvas: {
     *        width: `${width}px`,
     *        height: `${height}px`
     *    }
     * @param type selector tag|id|class, default class.
     */
    setStyle = (object, type = '.') => {
        let styles = '';
        for (let prefix in object) {
            if (object.hasOwnProperty(prefix)) {
                let fields = this.verifyField(object, prefix);
                if (!this.isEmpty(fields)) {
                    styles += `${type}${this.toSlug(prefix)}{`;
                    for (let field in fields) {
                        if (fields.hasOwnProperty(field)) {
                            let value = this.verifyField(object, `${prefix}.${field}`);
                            value && (styles += `${this.toSlug(field)}:${value};`);
                        }
                    }
                    styles += '}';
                }
            }
        }
        this.state.text = styles;
    };
}

/**
 *
 * @type {{}}
 */
SupportStyle.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
SupportStyle.defaultProps = {
    current_name: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportStyle, {className: 'SupportStyle'});
